import './src/style.css'
import VueAudio from './src/VueAudio.vue'

export default VueAudio
export { VueAudio }



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-audio/index.js
// module id = iCN3
// module chunks = 0